module.exports = __webpack_public_path__ + "static/media/general.d88db0fb.png";